import React, { useEffect, useRef, useState } from 'react'
import { useGetCurrentUserQuery, useLoginMutation } from '../../services/authApi'
import { useGoogleLoginMutation } from '../../services/googleAuthApi';
import { Link, useNavigate } from 'react-router-dom'
import { useGoogleLogin, GoogleLogin } from '@react-oauth/google'
// import { GoogleLogin } from '@react-oauth/google'
import Input from './Input'
import loader from '../../assets/images/loader.gif'
import { OTP_TIMER } from '../../keys'



const Left = () => {
    const [login, { isLoading, isError, error }] = useLoginMutation()
    // console.log("ERR",error)
    const [googleLogin, { isLoading: isGoogleLoading }] = useGoogleLoginMutation()

    const [isSignupLoading] = useState(false);
    const [message, setMessage] = useState('')
    const [email, setEmail] = useState('')
    const navigate = useNavigate()
    const form = useRef(null)
    const [iAgree, setIAgree] = useState(false)
    const [checkProfile, setCheckProfile] = useState(false)

    const { data: userDetails } = useGetCurrentUserQuery({}, { skip: !checkProfile })
    console.log("userDetails", userDetails)
    useEffect(() => {
        if (!checkProfile || !userDetails) return

        const profile = userDetails?.data
        console.log("profile", profile)
        if (profile?.name === null) {
            // New Google user — incomplete profile
            navigate('/register', {
                state: {
                    from_google: true,
                    email: localStorage.getItem('google_email') ?? '',
                    first_name: localStorage.getItem('google_first_name') ?? '',
                    last_name: localStorage.getItem('google_last_name') ?? '',
                }
            })
            return
        }
        if (profile?.user_type === 'coach') {
            navigate('/coach-welcome')
        }
        else {
            // Existing user — go to welcome
            navigate('/welcome')
        }
    }, [userDetails, checkProfile])

    const handleLogin = async (e) => {
        e.preventDefault()
        const formData = new FormData(form.current)
        // console.log(formData)
        const response = await login(formData)
        // console.log('REDDDDDDDDDDDDDDD', response)
        //~ this formData param is what you gave in query method (RTK Query)
        const data = await response.data
        try {
            if (response?.data?.code === 'Success') {
                setMessage(data.message)
                localStorage.setItem('email', email)
                localStorage.setItem('OTP_TIMER', OTP_TIMER) //vk
                // navigate('/otp')
                // For Register Page
                navigate('/otp', { state: { otp_type: 'login' } });

            } else if (response?.error?.status == 400) {
                response?.error?.data?.message == 'Something went wrong'
                    ? setMessage(response?.error?.data?.data?.email[0])
                    : response?.error?.data?.message ==
                        'Something went wrong while inserting user.'
                        ? setMessage(response?.error?.data?.message)
                        : response?.error?.data?.message == 'User is blocked.'
                            ? setMessage('User is blocked.')
                            : setMessage('please try after sometime.')
            } else if (response?.error?.originalStatus == 500) {
                setMessage('Invalid email id. Please provide a valid one!')
            }
        } catch (error) {
            setMessage('Some error occured! Please try again.')
        }
    }

    // ── Google SSO flow ───────────────────────────────────────────────────

    //  const handleGoogleSuccess = async (credentialResponse) => {
    //         setMessage('')
    //         try {
    //             const idToken = credentialResponse.credential

    //             // Decode ID token (JWT) to extract profile without extra API call
    //             const base64Url = idToken.split('.')[1]
    //             const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
    //             const profile = JSON.parse(window.atob(base64))

    //             const payload = {
    //                 google_token: idToken,
    //                 email:        profile.email        ?? '',
    //                 first_name:   profile.given_name   ?? '',
    //                 last_name:    profile.family_name  ?? '',
    //             }
    //  const handleGoogleSuccess = async (tokenResponse) => {
    //     setMessage('')
    //     try {
    //         // Get id_token from Google using the access_token
    //         const profileRes = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
    //             headers: { Authorization: `Bearer ${tokenResponse.access_token}` }
    //         })
    //         const profile = await profileRes.json()

    //         // Get the id_token — use authorization_code flow instead
    //         const payload = {
    //             google_token: tokenResponse.access_token,
    //             email:        profile.email        ?? '',
    //             first_name:   profile.given_name   ?? '',
    //             last_name:    profile.family_name  ?? '',
    //         }
    //             const response = await googleLogin(payload)
    //             const data = response?.data
    //  console.log(data);

    //             if (data?.data?.access) {
    //                 console.log("g");

    //                 localStorage.setItem('livtoken',  data?.data?.access)
    //                 localStorage.setItem('refresh_token', data?.data?.refresh)
    //                  setCheckProfile(true) // trigger profile check to route correctly
    //                 // navigate('/welcome')
    //             } else {
    //                 setMessage(
    //                     response?.error?.data?.message ?? 'Google sign-in failed. Please try again.'
    //                 )
    //             }
    //         } catch (err) {
    //             console.error('Google login error:', err)
    //             setMessage('Google sign-in failed. Please try again.')
    //         }
    //     }
    const handleGoogleSuccess = async (credentialResponse) => {
        setMessage('')
        try {
            const idToken = credentialResponse.credential  // ← must be .credential not .access_token

            if (!idToken) {
                setMessage('Google sign-in failed. Please try again.')
                return
            }

            const base64Url = idToken.split('.')[1]
            const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/')
            const profile = JSON.parse(window.atob(base64))

            const payload = {
                google_token: idToken,           // ← sending id token (JWT)
                email: profile.email ?? '',
                first_name: profile.given_name ?? '',
                last_name: profile.family_name ?? '',
            }

            console.log('payload', payload)  // ← check google_token is not empty

            const response = await googleLogin(payload)
            const data = response?.data

            if (data?.data?.access) {
                localStorage.setItem('livtoken', data.data.access)
                localStorage.setItem('refresh_token', data.data.refresh)
                localStorage.setItem('google_email', profile.email ?? '')
                localStorage.setItem('google_first_name', profile.given_name ?? '')
                localStorage.setItem('google_last_name', profile.family_name ?? '')
                setCheckProfile(true)
            } else {
                setMessage(
                    response?.error?.data?.message ?? 'Google sign-in failed. Please try again.'
                )
            }
        } catch (err) {
            console.error('Google login error:', err)
            setMessage('Google sign-in failed. Please try again.')
        }
    }
    const triggerGoogleLogin = useGoogleLogin({
        onSuccess: handleGoogleSuccess,
        onError: () => setMessage('Google sign-in was cancelled or failed.'),
        flow: 'implicit',  // returns id_token directly
    })
    // const saveIAgree = () => {
    //     let IAgreeCheckbox = document.getElementById('iAgree').checked
    //     localStorage.setItem('TnCP', IAgreeCheckbox)
    //     setIAgree(IAgreeCheckbox.checked)
    // }
    const saveIAgree = () => {
        const checked = document.getElementById('iAgree').checked  // ← boolean
        localStorage.setItem('TnCP', checked)
        setIAgree(checked)  // ← directly set the boolean
    }

    // useEffect(() => {
    //     if (JSON.parse(localStorage.getItem('TnCP')) === true) {
    //         document.getElementById('iAgree').checked = true
    //         setIAgree(true)
    //     } else {
    //         // console.log('No')
    //         setIAgree(false)
    //     }
    // }, [iAgree])
    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem('TnCP')) === true
        if (saved) {
            const el = document.getElementById('iAgree')
            if (el) el.checked = true
        }
        setIAgree(saved)
    }, [])
    console.log("mmmmmm", message)
    return (
        <div className="font-constantia w-3/5 xs:w-full md:w-full sm:w-full flex flex-col justify-center items-center">
            <div className="w-4/5 h-[70vh] xs:h-[40vh] sm:h-[50vh] ">
                <h1 className=
                    "lp-lg:text-[2.5rem] text-5xl leading-[55px] xs:leading-[40px] xs:hidden xs:text-3xl mb-0 logintitle"
                //  "lp-lg:text-[2.5rem] lp-xl:text-5xl xs:hidden sm:hidden md:hidden lp-lg:leading-[45px] lp-xl:leading-[60px] xs:leading-[40px] xs:text-3xl"
                >
                    Unlimited access to Mental Health Therapists, Nutritionists,
                    <br /> Fitness and Habit coaches
                </h1>

                <h1 className="text-5xl  lg:hidden xl:hidden 2xl:hidden leading-[55px] xs:leading-[40px] xs:text-3xl mobilelogin">
                    Welcome to <b>Hapsmiths</b>, <br /> Let's get started!
                </h1>

                <form ref={form} onSubmit={handleLogin}>
                    <Input
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={'Enter email id'}
                        type="email"
                        className="w-full max-w-md font-ubuntu placeholder:text-xs rounded-[30px] !p-4 mt-16 xs:mt-8 mb-4 focus:outline-none h-[40px]"
                    />

                    <div className="ml-2 mb-2 font-ubuntu text-sm text-gray-500">
                        <span>
                            By continuing, you freely consent and agree to
                            Hapsmiths{' '}
                            <Link
                                to="/terms-conditions-privacy"
                                className="underline"
                                target="_blank"
                            >
                                Terms and Conditions and Privacy Policy.
                            </Link>
                        </span>
                        <label
                            htmlFor="iAgree"
                            className="block cursor-pointer mt-2"
                            onClick={saveIAgree}
                        >
                            <input
                                name="i_agree"
                                type="checkbox"
                                id="iAgree"
                                onChange={saveIAgree}
                                className="cursor-pointer mt-2"
                            />{' '}
                            I Agree
                        </label>
                    </div>

                    <div className="flex gap-6">
                        <button
                            type="submit"
                            disabled={isLoading || !iAgree}
                            className="bg-[#FFDBB0] flex justify-center xs:w-full w-[300px] font-ubuntu items-center text-center h-[40px] rounded-[20px] font-bold text-[#F77F1F]"
                        >
                            {!isLoading && <>Login</>}{' '}
                            {isLoading && (
                                <img src={loader} className="w-8 h-8" alt="" />
                            )}
                        </button>

                        <a
                            href="/register"
                            disabled={isSignupLoading}
                            className="bg-[#F77611] flex justify-center xs:w-full w-[300px] font-ubuntu items-center text-center h-[40px] rounded-[20px] font-bold text-[#FFFFFF]"
                        >
                            {!isSignupLoading && <>Signup</>}{' '}
                            {isSignupLoading && (
                                <img src={loader} className="w-8 h-8" alt="" />
                            )}
                        </a>
                    </div>
                </form>


                {/* ── Divider ── */}
                <div className="flex items-center gap-3 my-4 max-w-md font-ubuntu text-sm text-gray-400">
                    <hr className="flex-1 border-gray-300" />
                    <span>or</span>
                    <hr className="flex-1 border-gray-300" />
                </div>

                {/* ── Google Login / Signup button ── */}

                {/* <div className={!iAgree ? 'opacity-50 pointer-events-none' : ''}>
                     
                  <div style={{  transformOrigin: 'left center',maxWidth: '400px' }} className="w-[400px]">
    <GoogleLogin
        onSuccess={handleGoogleSuccess}
        onError={() => setMessage('Google sign-in was cancelled or failed.')}
        // width={385}
    />
</div> 
    
</div> */}
                {/* Replace the Google button section with this */}
                <div className={!iAgree ? 'opacity-50 pointer-events-none' : ''}>
                    <div className="relative w-full max-w-md h-[40px]">

                        
                        <div className="absolute justify-center inset-0 w-full font-ubuntu rounded-[30px] border border-gray-200 shadow-md bg-white flex items-center px-4 gap-3 text-sm text-gray-600 pointer-events-none z-0">
                            <svg width="18" height="18" viewBox="0 0 48 48">
                                <path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z" />
                                <path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z" />
                                <path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z" />
                                <path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z" />
                            </svg>
                            <span className="font-medium text-gray-700">Continue with Google</span>
                        </div>

                      
                        <div
                            className="absolute inset-0 z-10 overflow-hidden rounded-[30px]"
                            style={{ opacity: 0.01 }}
                        >
                            <div style={{ transform: 'scale(3)', transformOrigin: 'top left', marginTop: '-4px' }}>
                                <GoogleLogin
                                    onSuccess={handleGoogleSuccess}
                                    onError={() => setMessage('Google sign-in was cancelled or failed.')}
                                    width="600"
                                />
                            </div>
                        </div>

                    </div>
                </div>

                {!iAgree && (
                    <p className="mt-2 text-xs text-orange-400 font-ubuntu">
                        Please agree to the Terms & Conditions to use Google sign-in.
                    </p>
                )}

                {message && (
                    <span className="block mt-3 font-ubuntu text-sm text-red-500">
                        {message.includes("Invalid Google Token")
                            ? "Google sign-in failed. Please try again."
                            : message}
                    </span>
                )}
            </div>
        </div>
    )
}

export default Left
